import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function Footer() {
  const { t } = useTranslation();

  const quickLinks = [
    { label: t('home'), href: '/' },
    { label: t('articles'), href: '/article/allchinabuy-spreadsheet-guide' },
    { label: t('categories'), href: '/' },
    { label: t('reviews'), href: '/article/allchinabuy-review-2026' },
  ];

  const resourceLinks = [
    { label: t('shipping'), href: '/article/allchinabuy-shipping-cost' },
    { label: t('coupon'), href: '/article/allchinabuy-coupon' },
    { label: t('warehouse'), href: '/article/allchinabuy-warehouse-guide' },
    { label: t('legit'), href: '/article/is-allchinabuy-legit' },
  ];

  const legalLinks = [
    { label: t('privacy'), href: '/privacy-policy' },
    { label: t('terms'), href: '/terms' },
    { label: t('disclaimer'), href: '/disclaimer' },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="lg:col-span-1">
            <Link
              to="/"
              className="text-lg font-bold tracking-tight text-foreground-950"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              {t('siteName')}
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              {t('footerDesc')}
            </p>
            <p className="mt-2 text-xs text-foreground-500">
              {t('notAffiliated')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 uppercase tracking-wider mb-4">
              {t('quickLinks')}
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 uppercase tracking-wider mb-4">
              {t('resources')}
            </h4>
            <ul className="space-y-2.5">
              {resourceLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 uppercase tracking-wider mb-4">
              {t('legal')}
            </h4>
            <ul className="space-y-2.5">
              {legalLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} allchinabuyspread.guru. {t('copyright')}
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors"
          >
            {t('visitMainSite')} &rarr;
          </a>
        </div>
      </div>
    </footer>
  );
}